import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 20h4a4 4 0 1 0 0 -8h-4v-8h8","key":"svg-0"}]]

const IconNumber5 = createReactComponent('outline', 'number-5', 'Number5', __iconNode);

export default IconNumber5;